<li class="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white dark:bg-zinc-900  shadow">
    <div
        class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:outline-1 dark:-outline-offset-1 dark:outline-white/10">
        <div (click)="videoPreview()" class="p-2 relative">
            <atom-video-thumbnail [videoUrl]="creator.video_file.s3_url"
                [thumbnailURL]="creator.video_file.cover && creator.video_file.cover !== '' ? creator.video_file.cover : undefined"
                [videoFormat]="VideoFormatEnum.Vertical" [thumb_cdn_size]="'gallery'"></atom-video-thumbnail>
        </div>
        <div (click)="launchPortfolio()" class="flex space-x-3 p-2 hover:cursor-pointer">
            <div class="shrink-0">
                <img [src]="imageService.getImageSource(creator.creator.photoURL, 'gallery')" alt=""
                    class="size-10 rounded-full bg-gray-800 outline -outline-offset-1 outline-white/10" />
            </div>
            <div class="flex flex-row items-center justify-between w-full">
                <div class="min-w-0 flex-1">
                    <p class="text-sm font-semibold text-white">
                        <a class="hover:underline">{{ creator.creator.firstName }} {{
                            creator.creator.lastName.charAt(0) }}.</a>
                    </p>
                    <p class="text-sm text-gray-400">
                        {{ formatService.getFlag(creator.creator) }} {{ creator.creator.homeTownName ?
                        creator.creator.homeTownName : 'Unset' }}
                    </p>
                </div>

                <div class="shrink-0 inline-flex gap-1.5 items-center pr-2 text-primary">
                    <p class="text-lg font-bold">4.5</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4">
                        <path
                            d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                    </svg>
                </div>

            </div>

        </div>
    </div>
</li>